module.exports = __webpack_public_path__ + "854d835e7216d96c37e5489863b14640.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2022_chart.png
// module id = 1651
// module chunks = 0